import { ServiceAdvisorRoutingModule } from './service-advisor-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceAdvisorComponent } from './service-advisor.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    declarations: [ServiceAdvisorComponent],
    imports: [
        CommonModule,
        ServiceAdvisorRoutingModule,
        SharedModule,
        TranslateModule
    ],
    exports: [TranslateModule]
})
export class ServiceAdvisorModule { }
